
<template>
    <main id="case">
        
        <section 
            v-for="(item, caseIndex) in items"
            :key="caseIndex"
            class="case"
            ref="caseNode"
        >
            
            <div class="media" ref="mediaNode">
                
                <!-- Blank <componente>. Use ":is" to define which component to use -->
                <component 
                    v-for="(media, index) in item.media" 
                    :key="index" 
                    :is="getComponentName(media.type)" 
                    :data="media" 
                    @loaded="componentLoaded"
                    @click.native="onClickMedia(caseIndex, index, media.type)" 
                />
                
            </div>
            
            <div class="copy" ref="copyNode">
                <!-- DESKTOP Header-->
                <div class="header" v-if="!isMobileLayout">
                    <h1>
                        <span class="uppercase">{{item.client}}</span>
                        <br>
                        {{item.tags}}
                        <span v-if="item.year" class="year">
                            {{item.year}}
                        </span>
                    </h1>
                </div>
                <div class="description" v-html="item.description"></div>
                <div class="links" v-for="(link, linkIndex) in item.links" :key="linkIndex">
                    <a :href="link.url" tager="_blank">{{link.text}}</a>
                </div>
            </div>
            
            <!-- MOBILE Header-->
            <div class="header" v-if="isMobileLayout">
                <h1>
                    <span class="uppercase">{{item.client}}</span>
                    <br>
                    {{item.tags}}
                    <span v-if="item.year" class="year">
                        {{item.year}}
                    </span>
                </h1>
            </div>
        </section>
        
        <SecondaryNavigation 
            text="View all Work"
            :showCloseIcon="true"
            :hasLink="true"
            @clicked="this.onCloseCase"
        />
        
    </main>
</template>

<script>
import axios from 'axios'
import { TweenLite } from 'gsap/all'
import Scroll from '@/plugins/WindowScroll'
import Size from '@/plugins/WindowSize'
import SecondaryNavigation from '@/components/SecondaryNavigation'

// Media Components
import MediaImage from '@/components/MediaImage'
import MediaVideo from '@/components/MediaVideo'
import MediaCarousel from '@/components/MediaCarousel'
import MediaColumnLayout from '@/components/MediaColumnLayout'
import MediaEmbedVimeo from '@/components/MediaEmbedVimeo'


export default {
    components: {
        SecondaryNavigation,
        MediaImage,
        MediaVideo,
        MediaCarousel,
        MediaColumnLayout,
        MediaEmbedVimeo
    },
    
    props: {
        workFilter: {
            type: String,
            default: 'all',
        },
        routeFromWork: {
            type: Boolean,
            default: false,
        },
    },
    
    data() {
        return {
			items: [],
            loading: false,
			pageTotal: 0,
            isLastPage: false,
			pageCurrent: 1,
            isFullscreen: false,
            margin: 0,
            componentsLoaded: 0,
            isMobileLayout: true,
        }
    },
    
    created() {
        Scroll.addListener(this.onScroll)
        Size.addListener(this.onResize)
    },
    
    destroyed() {
        Scroll.removeListener(this.onScroll)
        Size.removeListener(this.onResize)
    },
    
    mounted() {
        this.getData(this.pageCurrent, true)
        this.onResize()
    },
    
    methods: {
        
		getData(page, firstLoad = false) {
			if (this.loading) {
				return
			}
            // TODO this.isFirstPage
            
			let filter = this.workFilter || ""
            let url = "/data/case-" + page + ".json" + (filter ? "?filter=" + filter : "")

            this.loading = true
            
			return axios
				.get(url)
				.then(res => {
					this.pageCurrent = res.data.pageCurrent
                    
					if (firstLoad) {
                        // this.itemsPerPage = res.data.itemsPerPage
						this.pageTotal = res.data.pageTotal
						this.items = res.data.works
					} else {
                        this.items = this.items.concat(res.data.works)
					}
                    this.isLastPage = this.pageCurrent === this.pageTotal
                    console.log('Loaded JSON: ', this.isLastPage, this.pageCurrent, this.pageTotal);
                    this.loading = false
                    
                    this.$emit('loaded') // Tell App data is ready
				})
				.catch(error => {
                    throw new Error('Data Failed: ', error);
                })
                
        },
        
        onClickMedia(caseIndex, mediaIndex, mediaType) {
            

            if (window.innerWidth < 1024) return

            this.isFullscreen = !this.isFullscreen
            
            // OPEN
            if (this.isFullscreen === true) {
                
                this.$store.dispatch('caseFullWidth') // Vuex - Used by child components
                this.openFullwidth(caseIndex, mediaIndex, event.currentTarget)
            }
            // CLOSE
            else {
                if (mediaType === 'media-embed-vimeo') return // IF - clicked component is vimeo embed
                
                this.$store.dispatch('caseHalfWidth') // Vuex - Used by child components
                this.closeHalfwidth(caseIndex, mediaIndex, event.currentTarget)
            }
        },
        
        openFullwidth(caseIndex, mediaIndex, node) {
            
            var selectedCopyNode = this.$refs.copyNode[caseIndex]
            var lastChild = selectedCopyNode.lastElementChild
            var textHeight = lastChild.offsetTop + lastChild.offsetHeight

            TweenLite.to(this.$refs.mediaNode[caseIndex], 0.6, {
                width: '100%',
                top: textHeight +'px', 
                paddingBottom: textHeight +'px', 
                ease: Power4.easeOut, 
            })
            
            // No Zoom on the very first image
            if (caseIndex === 0 && mediaIndex === 0) {return;}
            
            // Calculate scroll position
            var caseTop = this.$refs.caseNode[caseIndex].getBoundingClientRect().top + window.scrollY
            var h = node.offsetTop
            var w = node.offsetWidth
            var newW = this.$refs.caseNode[caseIndex].offsetWidth
            var as = h/w
            var height = Math.floor(as*newW)
            // console.log(h, w, newW, caseTop)
            TweenLite.to(window, 0.6, {scrollTo: (height + caseTop) + textHeight, ease: Power4.easeOut});
        },

        closeHalfwidth(caseIndex, mediaIndex, node) {
            
            TweenLite.to(this.$refs.mediaNode[caseIndex], 0.8, {
                width: '50%',
                top: 0, 
                paddingBottom: 0, 
                ease: Power4.easeOut, 
            })
            
            // No Zoom on the very first image
            if (caseIndex === 0 && mediaIndex === 0 ) {return;}
            
            var caseTop = this.$refs.caseNode[caseIndex].getBoundingClientRect().top + window.scrollY
            var h = node.offsetTop
            var w = node.offsetWidth
            var newW = w/2
            var as = h/w
            var height = Math.floor(as*newW)
            // console.log(h, w, newW, caseTop)
            TweenLite.to(window, 0.8, {scrollTo: (height + caseTop), ease: Power4.easeOut});
        },
        
        componentLoaded() {
            this.componentsLoaded++
            if (this.componentsLoaded === this.items.length) {
                this.$emit('loaded')
            }
        },
         
        onCloseCase() {
            if (this.routeFromWork === true) {
                // go back to /work using history
                this.$router.go(-1)
            } else {
                // push new route
                this.$router.push({ name: 'Work' })    
            }
        },
        
        getComponentName(type) {
            // Components are: MediaImage, MediaVideo, MediaCarousel, MediaColumnLayout, MediaEmbedVideo
            var camelCased = type.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
            var name = camelCased.charAt(0).toUpperCase() + camelCased.slice(1) // Uppsercase first letter
            return name
        },
        
        
        reachingPageBottom(offset) {
            return window.pageYOffset + window.innerHeight >= document.body.scrollHeight - (offset || 0)
        },
        
        onScroll() {
            if (this.isLastPage) return;
            
            if (this.reachingPageBottom(window.innerHeight)) {
                console.log('reached bottom');
                this.getData(this.pageCurrent+1)
            }
        },
        
        onResize() {
            this.isMobileLayout = (Size.width > 1024) ? false : true
        }
        
    },
}
</script>

<style lang="scss" scoped>

@import '../scss/variables';
@import '../scss/font-scaling';

#case {
    @include page-padding;
    
    @media (min-width: $tablet) {
        padding-top: 40px;
    }
    
    .case {
        display: flex;
        flex-direction: column-reverse;
        
        position: relative;
        margin-bottom: 35%;
        font-size: 0;
        
        @media (min-width: $tablet) {
            margin-bottom: 20%;
            display: block;
            flex-direction: unset;
        }
        
        
        .media,
        .copy {
            display: inline-block;
            vertical-align: top;
        }

        .media {
            position: relative;
            width: 100%;
            transform-origin: top left;
            
            @media (min-width: $tablet) {
                width: 50%;
            }
            .media-image,
            .media-video,
            .media-carousel,
            .media-column-layout,
            .embed-video {
                margin-bottom: 2%;
                
                // &:first-child {
                //     margin-top: calc(-50px) // 20px from top
                // }
                &:last-child {
                    margin-bottom: 0;
                }
                
            }
        }
        
        
        .copy {
            position: relative;
            width: 100%;
            max-width: 700px;
            margin-bottom: 6%;
            pointer-events: none;
            
            @media (min-width: $tablet) {
                position: absolute;
                top: 0px;
                bottom: 50px;
                width: calc(50% - 40px);
                left: calc(50% + 40px);
                margin-bottom: 0;
            }
            
            
            .description {
                pointer-events: auto;
                min-height: 20px;
                padding-top: 1.4em; // 0.3em*2 = Optical adjustment
                padding-bottom: 1.4em;
                
                font-size: 13px;
                line-height: 1.4em;
                font-weight: 400;
                
                @media (min-width: $tablet) {
                    font-size: 15px;
                }
                
                // https://vue-loader.vuejs.org/guide/scoped-css.html#deep-selectors
                ::v-deep p {
                    font-size: inherit;
                    line-height: inherit;
                    
                    &.indent {
                        text-indent: 2em; // indent line - Create class selector in WP
                    }
                }
                
                ::v-deep a {
                    font-size: inherit;
                    line-height: inherit;
                    font-weight: 400;
                    text-decoration: underline;
                }
                
                ::v-deep br {
                    display: block;
                    margin: 10px 0;
                }
            }
            
            .links {
                pointer-events: auto;
                
                &:last-child {
                    padding-bottom: 40px; // only desktop?
                }
                
                a {
                    text-decoration: underline;
                    font-size: 13px;
                    line-height: 1.4em;
                    font-weight: 400;
                    
                    @media (min-width: $tablet) {
                        @include FluidFontStart(1024, 1600, 12, 16);
                        @include FluidFontEndless(1600, 16, .4);
                    }
                }
            }
        }
        
        
        // .header is wrapped by .copy in desktop
        .header {
            top: 80px;
            position: sticky;
            
            @media (min-width: $tablet) {
                top: 36px;
            }
            
            h1 {    
                font-size: 20px;
                line-height: 1.2em;
                font-weight: 400;
                margin-top: -0.3em;
                
                @media (min-width: $tablet) {
                    font-size: 28px;
                    line-height: 30px;
                }
                
                .uppercase {
                    text-transform: uppercase;        
                }
                
                .year {
                    position: relative;
                    font-size: 0.5em;
                    top: -0.7em;
                }
            }
        }
    }
}
</style>
